import { Menu, Group, ActionIcon, Text, Button, Tooltip } from "@mantine/core";
import {
  IconDots,
  IconSettings,
  IconMessageCircle,
  IconPhoto,
  IconSearch,
  IconArrowsLeftRight,
  IconTrash,
} from "@tabler/icons";

import { useTranslation } from "react-i18next";

const renderActionButtons = (actions, data, onActionBtnClick, rowIndex) => {
  return actions.map((action, index) => (
    <Tooltip
      key={index}
      label={action.label}
      position="top"
      withArrow
      openDelay={500}
    >
      <ActionIcon
        size="sm"
        variant="subtle"
        onClick={(e) => {
          e.stopPropagation();
          onActionBtnClick({ action: action.name, data, rowIndex });
        }}
      >
        <action.icon
          size={action.iconSize ?? 16}
          stroke={action.stroke ?? 1.5}
          {...action.props}
        />
      </ActionIcon>
    </Tooltip>
  ));
};

const renderActionMenu = (actionMenu, data, onActionBtnClick, rowIndex) => {
  if (!actionMenu || actionMenu.length == 0) return;

  return (
    <Menu transition="pop" withArrow position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <IconDots size={16} stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown py={"xs"}>
        {actionMenu.map((action, index) => {
          const visible =
            typeof action.visible === "function"
              ? action.visible(data)
              : action.visible !== false;
          if (!visible) return null;

          const disabled =
            typeof action.props?.disabled === "function"
              ? action.props.disabled(data)
              : action.props?.disabled;
          const props = { ...action.props, disabled };
          const label =
            typeof action.label === "function"
              ? action.label(data)
              : action.label;

          const disabledStyle = disabled
            ? { opacity: 0.5, cursor: "not-allowed" }
            : {};

          return action.icon ? (
            <Menu.Item
              key={index}
              icon={<action.icon size={16} stroke={1.5} style={disabledStyle} />}
              {...props}
              style={disabledStyle}
              onClick={(e) => {
                e.stopPropagation();
                if (disabled) return;
                onActionBtnClick({ action: action.name, data, rowIndex });
              }}
            >
              <Text size="xs" color={disabled ? "dimmed" : undefined}>
                {label}
              </Text>
            </Menu.Item>
          ) : (
            <Menu.Item
              key={index}
              {...props}
              style={disabledStyle}
              onClick={(e) => {
                e.stopPropagation();
                if (disabled) return;
                onActionBtnClick({ action: action.name, data, rowIndex });
              }}
            >
              <Text size="xs" color={disabled ? "dimmed" : undefined}>
                {label}
              </Text>
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
};

const ActionCellRender = (column, rowIndex, data, onActionBtnClick) => {
  return (
    <Group spacing={4} noWrap position="right" align="center">
      {renderActionButtons(column.actions, data, onActionBtnClick, rowIndex)}
      {renderActionMenu(column.actionMenu, data, onActionBtnClick, rowIndex)}
    </Group>
  );
};

export default ActionCellRender;
